import { STATIC_IMAGES } from "utils/url.utils";
import styles from "./ContactInfo.module.scss";

export const ContactInfo = () => {
  return (
    <div className={styles.contactInfo}>
      <p className={styles.contactInfoText}>
        Have a logistics product, platform, or workflow that needs better data? Let’s talk.
      </p>
      <p className={styles.contactInfoText}>
        QubicTron helps companies connect to the infrastructure behind modern global shipping - from container tracking
        and freight rates to vessel schedules, transit time, freight market data, CO₂ calculations, and developer-ready
        APIs.
      </p>
      <p className={styles.contactInfoText}>
        Whether you are building a logistics platform, improving an existing TMS, connecting data to ERP or CRM systems,
        or looking for smarter ways to automate freight operations, our team is here to help you find the right
        solution.
      </p>
      <p className={styles.contactInfoText}>
        Reach out to QubicTron to discuss your use case, request API access, book a demo, or learn how our logistics
        technology can fit into your product. We work with freight forwarders, trading companies, e-commerce businesses,
        supply chain teams, and digital platforms that want faster, cleaner, and more reliable logistics data.
      </p>
      <p className={styles.contactInfoText}>
        Tell us what you are building - and we’ll help you connect it to the world of global trade.
      </p>
      <div className={styles.contactInfoLogoWrapper}>
        <img className={styles.contactInfoLogo} src={`${STATIC_IMAGES}/Icons/appLogo.svg`} alt="logo" />
      </div>
    </div>
  );
};
